import { http, HttpResponse } from "msw";
import { PlessService } from "src/app/shared/pless-service.model";

export const kymw7403Handlers = [
  http.post(
    PlessService.SERVICE.getOutputTarget.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getOutputTarget);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
    }
  ),
  http.post(
    PlessService.SERVICE.outputRememberGoodsInfo.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(outputRememberGoodsInfo);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
    }
  ),
  http.post(
    PlessService.SERVICE.outputRememberGoodsDiff.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(outputRememberGoodsDiff);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
    }
  )
]

const getOutputTarget = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: [
      {
        ConfirmDate:"2024/10/11 12:50:31",  // 確定日時
        ConfirmUserId:"test01",             // 確定ユーザID
        ConfirmUserName:"テスト１"           // 確定ユーザ名
      },
      {
        ConfirmDate:"2024/10/29 15:01:06",
        ConfirmUserId:"test02",
        ConfirmUserName:"テスト２"
      },
      {
        ConfirmDate:"2024/04/09 09:01:06",
        ConfirmUserId:"12345678",
        ConfirmUserName:"テスト３テスト３テスト３テスト３テスト３テスト３テスト３テスト３テスト３テスト３"
      },
    ]
  }
}

const outputRememberGoodsInfo = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      FileName: "/tmp/peace/data/WebData/downloadtemp/KYMW0000_20240814_161931.csv"
    }
  }
}

const outputRememberGoodsDiff = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      FileName: "/tmp/peace/data/WebData/downloadtemp/KYMW0000_20240814_161931.csv"
    }
  }
}
